import React from 'react'
import {NatGetCondominiumAuthed} from '../repository/NatGetCondominiumAuthed'
import {Nullable} from '../../../../app/TypeHelpers'
import {
    StyledDd,
    StyledDiv,
    StyledDl,
    StyledDt,
    StyledI,
    StyledSpan,
} from '../../../../styledComponents/StyledTypeDefinitions'
import styled from 'styled-components'
import {BreakPoint, Colors, FontSize} from '../../../../styledComponents/Constants'
import {IconFont} from '../../../../styledComponents/ContentsArea'
import {generateMedia} from 'styled-media-query'
import {formatForDateInputDotSeparator} from '../../../../formatters/formatDate'
import {Messages} from '../../../../Messages'
import {LOGIN_MODE} from '../../../../CodeMaster'
import {SessionStorageHelper} from '../../../../SessionStorageHelper'
import {convertToRoomNumberForResident} from '../../../common/util/Natutil'

const KEY_LOGIN_MODE: string = 'loginMode'

interface Props {
    condominium: NatGetCondominiumAuthed | null
    CondominiumSelectClick: (
        condominiumCd: string,
        condominiumGroupId: number,
        ridgeCd: string,
        roomNumber: string) => void
}


export default class NatResidentCondominiumSelectReadComponent extends React.Component<Props> {
    constructor(props: Props) {
        super(props)
    }

    // 物件選択
    CondominiumSelectClick(
        condominiumCd: string,
        condominiumGroupId: number,
        ridgeCd: string,
        roomNumber: string,
    ): void {
        this.props.CondominiumSelectClick(condominiumCd, condominiumGroupId, ridgeCd, roomNumber)
    }

    // 部屋番号
    renderRoomNumber(ridgeName: string, roomNumber: string): Nullable<React.ReactElement> {
        if (SessionStorageHelper.getStringItemOrNull(KEY_LOGIN_MODE) !== LOGIN_MODE.ADMIN.value) {
            return (
                <RoomNumberWrapper>
                    「{ridgeName}{convertToRoomNumberForResident(roomNumber)}」
                </RoomNumberWrapper>
            )
        }
        return null
    }

    render(): Nullable<React.ReactElement> {
        if (this.props.condominium !== null &&
            this.props.condominium.details !== null &&
            this.props.condominium.details.condominiumInfo.length !== 0) {
            return (
                <>
                    {
                        this.props.condominium.details.condominiumInfo.map((condominiumInfo, index) =>
                            <BlockCondominiums key={index}>
                                <BlockCondominiumInfo>
                                    <CondominiumNameWrapper>
                                        <a href="javascript:void(0);"
                                           onClick={() =>
                                               this.CondominiumSelectClick(
                                                   condominiumInfo.condominiumCd,
                                                   condominiumInfo.condominiumGroupId,
                                                   condominiumInfo.ridgeCd,
                                                   condominiumInfo.roomNumber,
                                               )}>
                                            {condominiumInfo.condominiumName}
                                        </a>
                                    </CondominiumNameWrapper>
                                    {this.renderRoomNumber(condominiumInfo.ridgeName, condominiumInfo.roomNumber)}
                                </BlockCondominiumInfo>
                                <BlockStatus>
                                    <DateLabel>登録日</DateLabel>
                                    {formatForDateInputDotSeparator(`${condominiumInfo.registerDatetime}+09:00`)}
                                    <DateLabel>更新日</DateLabel>
                                    {formatForDateInputDotSeparator(`${condominiumInfo.updateDatetime}+09:00`)}
                                </BlockStatus>
                                <BlockCondominiumIcon>
                                    <CondominiumIcon/>
                                </BlockCondominiumIcon>
                            </BlockCondominiums>)
                    }
                </>
            )
        } else {
            return (
                <>
                    {SessionStorageHelper.getStringItemOrNull(KEY_LOGIN_MODE) === LOGIN_MODE.ADMIN.value &&
                        Messages.IOPCC0014.toString('')
                    }
                </>
            )
        }
    }
}

// ブレイクポイント
const breakPoint: any = generateMedia({
    sp: `${BreakPoint.Sp}`,
})

// 検索結果一覧
const BlockCondominiums: StyledDl = styled.dl`
    margin-top: 0;
    position: relative;
    padding: 0 0 0 64px;
`

// マンション情報
const BlockCondominiumInfo: StyledDt = styled.dt`
    margin: 0;
`

// マンション名
const CondominiumNameWrapper: StyledDiv = styled.div`
  display: inline-block;

  ${breakPoint.lessThan('sp')`
     display: block;
  `}
`

// 部屋番号
const RoomNumberWrapper: StyledDiv = styled.div`
  display: inline-block;
  padding-left: 15px;

  ${breakPoint.lessThan('sp')`
     display: block;
     padding: 0;
  `}
`

// ステータス情報
const BlockStatus: StyledDd = styled.dd`
    display: block;
    margin: 0 0 16px;
    padding: 0;
    font-size: ${FontSize.Small};
`

// 登録日/更新日
const DateLabel: StyledSpan = styled.span`
    margin: 0 5px 0 0.1em;
    padding: 2px 3.5px 0.1px;
    border-radius: 2px;
    background-color: ${Colors.Primary};
    color: ${Colors.Surface};
    display: inline-block;
`

// アイコン
const BlockCondominiumIcon: StyledDd = styled.dd`
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 56px;
    height: 56px;
    margin: 0;
    padding: 0;
    background-color: ${Colors.AccentLight};
    color: ${Colors.Surface};
    text-align: center;
    line-height: 56px;
`

// マンションアイコン
const CondominiumIcon: StyledI = styled.i`
  ${IconFont};
  font-size: 3.6rem;

  &::before {
      content: "\f102";
  }
`
